import { Engine } from 'engine/Engine';
import { Entity } from 'engine/Entity';
import { Facet } from 'engine/facets/Facet';

interface HittableProps {
  hit: (hitter: Entity, engine: Engine) => boolean,
}

export class Hittable extends Facet<HittableProps> {
}
